export const heroStats = [
  { label: '高清剧集', value: '10万+' },
  { label: '每日更新', value: '50+' },
  { label: '活跃用户', value: '800万+' },
];

export const cardsData = [
  {
    id: 'card-1',
    title: '热门推荐',
    description: '全网热播剧集实时追踪，精选高分好剧每日更新，追剧不再迷路',
    icon: 'ri-fire-line',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20warm%20composition%20with%20glowing%20fire%20elements%20and%20dramatic%20lighting%2C%20dark%20background%20with%20golden%20amber%20highlights%2C%20elegant%20minimalist%20aesthetic%2C%20film%20industry%20atmosphere%2C%20soft%20gradients%20and%20luxurious%20texture%2C%20no%20text%20or%20logos%2C%20abstract%20cinematic%20style&width=800&height=500&seq=card-hot-01&orientation=landscape',
  },
  {
    id: 'card-2',
    title: '最新上线',
    description: '第一时间同步各大平台新剧上线，不错过任何一部精彩好剧',
    icon: 'ri-flashlight-line',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20streaming%20platform%20concept%20with%20glowing%20neon%20accents%20on%20dark%20background%2C%20floating%20geometric%20shapes%20in%20warm%20coral%20and%20gold%20tones%2C%20cinematic%20atmosphere%20with%20soft%20bokeh%20effects%2C%20elegant%20abstract%20composition%2C%20no%20text%20or%20logos&width=800&height=500&seq=card-new-02&orientation=landscape',
  },
  {
    id: 'card-3',
    title: '高分经典',
    description: '豆瓣高分口碑剧集一网打尽，重温那些年我们追过的经典神作',
    icon: 'ri-star-line',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20cinema%20aesthetic%20with%20warm%20sepia%20tones%2C%20old%20film%20reels%20and%20theater%20spotlight%20on%20dark%20background%2C%20nostalgic%20atmosphere%20with%20golden%20particles%20floating%2C%20elegant%20classic%20movie%20vibe%2C%20soft%20gradients%2C%20no%20text%20or%20logos&width=800&height=500&seq=card-classic-03&orientation=landscape',
  },
  {
    id: 'card-4',
    title: '国产剧集',
    description: '国产精品电视剧汇聚，古装、都市、悬疑、年代剧应有尽有',
    icon: 'ri-building-2-line',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20traditional%20aesthetic%20with%20ink%20wash%20painting%20style%2C%20elegant%20mountain%20and%20water%20landscape%20in%20soft%20coral%20and%20gold%20hues%2C%20modern%20minimalist%20interpretation%20of%20classical%20Chinese%20art%2C%20dark%20background%20with%20warm%20accents%2C%20no%20text&width=800&height=500&seq=card-cn-04&orientation=landscape',
  },
  {
    id: 'card-5',
    title: '日韩剧场',
    description: '热门日剧韩剧独家收录，从浪漫爱情到悬疑烧脑，满足多元口味',
    icon: 'ri-global-line',
    image: 'https://readdy.ai/api/search-image?query=Modern%20East%20Asian%20urban%20nightscape%20with%20neon%20signs%20and%20warm%20street%20lights%2C%20cinematic%20color%20grading%20with%20coral%20and%20teal%20tones%2C%20atmospheric%20city%20vibe%20at%20night%2C%20soft%20bokeh%20background%2C%20elegant%20composition%2C%20no%20text%20or%20logos&width=800&height=500&seq=card-jk-05&orientation=landscape',
  },
  {
    id: 'card-6',
    title: '欧美精选',
    description: '精选欧美高分剧集，HBO、Netflix 等平台口碑大作一站畅享',
    icon: 'ri-film-line',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20Hollywood%20aesthetic%20with%20dramatic%20lighting%20and%20film%20noir%20atmosphere%2C%20dark%20background%20with%20golden%20spotlight%20rays%2C%20classic%20movie%20theater%20curtain%20texture%20in%20deep%20red%20tones%2C%20elegant%20and%20mysterious%20composition%2C%20no%20text%20or%20logos&width=800&height=500&seq=card-west-06&orientation=landscape',
  },
  {
    id: 'card-7',
    title: '动漫专区',
    description: '热门国漫日漫全收录，从热血战斗到治愈日常，二次元世界触手可及',
    icon: 'ri-rocket-line',
    image: 'https://readdy.ai/api/search-image?query=Anime%20inspired%20abstract%20art%20with%20vibrant%20coral%20and%20golden%20color%20palette%2C%20dynamic%20energy%20lines%20and%20particles%20on%20dark%20background%2C%20Japanese%20animation%20aesthetic%20blended%20with%20modern%20minimalist%20design%2C%20soft%20glow%20effects%2C%20no%20text%20or%20characters&width=800&height=500&seq=card-anime-07&orientation=landscape',
  },
];

export const mediaData = [
  {
    id: 'media-1',
    title: '长安十二时辰',
    subtitle: '古装悬疑 · 豆瓣 8.2',
    description: '大唐天宝三年，上元节前夕，长安城混入可疑狼卫，死囚张小敬临危受命，与李必携手在十二时辰内拯救长安。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20cityscape%20at%20night%20with%20lanterns%20and%20traditional%20architecture%2C%20dramatic%20mystery%20atmosphere%20with%20warm%20golden%20and%20deep%20red%20lighting%2C%20cinematic%20film%20poster%20style%2C%20dark%20background%20with%20glowing%20accents%2C%20epic%20scale%20composition&width=900&height=500&seq=media-changan-01&orientation=landscape',
    tag: '热播中',
  },
  {
    id: 'media-2',
    title: '狂飙',
    subtitle: '刑侦犯罪 · 豆瓣 8.5',
    description: '京海市一线刑警安欣与黑恶势力长达二十年的生死较量，展现了扫黑除恶工作中的惊心动魄。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20urban%20night%20scene%20with%20rainy%20street%20and%20police%20car%20lights%2C%20crime%20drama%20atmosphere%20with%20high%20contrast%20lighting%2C%20dark%20blue%20and%20coral%20color%20scheme%2C%20cinematic%20noir%20style%2C%20suspenseful%20mood%2C%20no%20text%20or%20faces&width=900&height=500&seq=media-kuangbiao-02&orientation=landscape',
    tag: '高分推荐',
  },
  {
    id: 'media-3',
    title: '三体',
    subtitle: '科幻巨制 · 豆瓣 8.7',
    description: '纳米科学家汪淼进入神秘游戏"三体"，揭开了地球文明与三体文明之间波澜壮阔的宇宙故事。',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20abstract%20composition%20with%20cosmic%20elements%20and%20nebula%20colors%2C%20dark%20space%20background%20with%20glowing%20coral%20and%20golden%20energy%20waves%2C%20mysterious%20and%20epic%20atmosphere%2C%20cinematic%20scale%2C%20minimalist%20design%2C%20no%20text&width=900&height=500&seq=media-santi-03&orientation=landscape',
    tag: '重磅推荐',
  },
  {
    id: 'media-4',
    title: '庆余年',
    subtitle: '古装权谋 · 豆瓣 7.9',
    description: '身世神秘的少年范闲，在庆国京都历经家族、江湖、庙堂的种种考验，书写了一段波澜壮阔的人生传奇。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20palace%20aesthetic%20with%20golden%20rooftops%20and%20morning%20mist%2C%20warm%20sunlight%20through%20clouds%2C%20dramatic%20and%20elegant%20atmosphere%2C%20traditional%20Chinese%20painting%20style%20blended%20with%20cinematic%20lighting%2C%20epic%20composition&width=900&height=500&seq=media-qingyun-04&orientation=landscape',
    tag: '经典回顾',
  },
  {
    id: 'media-5',
    title: '隐秘的角落',
    subtitle: '悬疑剧情 · 豆瓣 8.8',
    description: '三个孩子在景区游玩时无意拍摄记录了一场谋杀，由此展开了一场关于善恶、救赎与成长的惊心故事。',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20coastal%20town%20at%20sunset%20with%20dramatic%20shadows%20and%20warm%20golden%20light%2C%20psychological%20thriller%20atmosphere%2C%20dark%20and%20moody%20aesthetic%20with%20coral%20accents%2C%20cinematic%20film%20poster%20style%2C%20suspenseful%20composition&width=900&height=500&seq=media-yinmi-05&orientation=landscape',
    tag: '必看神作',
  },
];

export const carouselData = [
  {
    id: 'carousel-1',
    title: '古装剧盛宴',
    subtitle: '穿越千年，品味国风之美',
    description: '精选年度最受瞩目的古装大剧，从权谋宫斗到仙侠玄幻，每一帧都是视觉盛宴。服化道精良、剧情扣人心弦，带你领略中华文化的博大精深。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20with%20flowing%20silk%20curtains%20and%20golden%20lanterns%2C%20dramatic%20cinematic%20lighting%20with%20warm%20coral%20and%20amber%20tones%2C%20ethereal%20atmosphere%20with%20floating%20particles%2C%20elegant%20traditional%20aesthetic%2C%20epic%20composition&width=700&height=400&seq=carousel-ancient-01&orientation=landscape',
    tag: '年度专题',
  },
  {
    id: 'carousel-2',
    title: '烧脑悬疑季',
    subtitle: '真相只有一个，等你来揭晓',
    description: '迷雾剧场全线集结！国内外顶级悬疑剧作轮番上阵，反转不断、细节密布。从国产刑侦到美剧探案，每一部都让你欲罢不能。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20alleyway%20with%20single%20warm%20streetlamp%20and%20fog%2C%20film%20noir%20aesthetic%20with%20dramatic%20shadows%2C%20coral%20and%20deep%20charcoal%20color%20palette%2C%20cinematic%20detective%20atmosphere%2C%20suspenseful%20mood%2C%20no%20text&width=700&height=400&seq=carousel-suspense-02&orientation=landscape',
    tag: '迷雾剧场',
  },
  {
    id: 'carousel-3',
    title: '治愈温情档',
    subtitle: '温暖人心的故事，陪你度过每一天',
    description: '生活需要一点温暖。从家庭伦理到都市爱情，从成长励志到人间烟火。这些触动人心的好剧，总有一个故事让你热泪盈眶。',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20living%20room%20with%20warm%20sunlight%20streaming%20through%20window%2C%20soft%20blankets%20and%20warm%20tea%2C%20golden%20hour%20ambient%20lighting%2C%20comfortable%20and%20intimate%20atmosphere%2C%20cinematic%20composition%20with%20shallow%20depth%20of%20field%2C%20no%20text&width=700&height=400&seq=carousel-warm-03&orientation=landscape',
    tag: '温情推荐',
  },
  {
    id: 'carousel-4',
    title: '科幻奇幻汇',
    subtitle: '突破想象边界，开启异世界之旅',
    description: '从硬核科幻到东方玄幻，从平行宇宙到魔法世界。顶级视效团队打造，每一部都是想象力的极致呈现。准备好了吗？出发！',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20portal%20with%20glowing%20energy%20rings%20and%20floating%20crystalline%20structures%2C%20deep%20space%20background%20with%20nebula%20in%20coral%20and%20gold%20hues%2C%20sci-fi%20fantasy%20aesthetic%2C%20epic%20cinematic%20scale%2C%20mysterious%20and%20wondrous%20atmosphere&width=700&height=400&seq=carousel-scifi-04&orientation=landscape',
    tag: '脑洞大开',
  },
];

export const updatesData = [
  {
    id: 'update-1',
    time: '07-31',
    title: '《大奉打更人》全集上线',
    description: '许七安穿越古代化身打更人，破奇案、掌权柄，全集一次放出等你来追！',
    tag: '新剧上线',
  },
  {
    id: 'update-2',
    time: '07-30',
    title: '《繁花》4K修复版独家呈现',
    description: '王家卫导演首部电视剧，沪上风情尽收眼底，高清画质带来全新观影体验。',
    tag: '高清修复',
  },
  {
    id: 'update-3',
    time: '07-29',
    title: '暑期追剧季 · 百部好剧免费看',
    description: '即日起至8月底，百余部精选剧集限时免费，涵盖古装、悬疑、爱情等全类型。',
    tag: '限时福利',
  },
  {
    id: 'update-4',
    time: '07-28',
    title: '《猎罪图鉴2》即将上线，预约已破百万',
    description: '檀健次、金世佳携原班人马回归，模拟画像师再破悬案，平台独家首播倒计时。',
    tag: '即将上线',
  },
  {
    id: 'update-5',
    time: '07-27',
    title: '播放体验全面升级',
    description: '服务器扩容完成，4K超清播放更流畅，支持多端同步观看进度，追剧不中断。',
    tag: '平台升级',
  },
  {
    id: 'update-6',
    time: '07-26',
    title: '《唐诡2》完结，第三季官宣启动',
    description: '口碑神作《唐朝诡事录2》完美收官，编剧透露第三季已进入筹备阶段。',
    tag: '剧集动态',
  },
  {
    id: 'update-7',
    time: '07-25',
    title: '日韩剧场大扩容 · 50部新剧入库',
    description: '引进多部口碑日剧韩剧，涵盖悬疑、爱情、职场等多种题材，字幕组精翻保障。',
    tag: '资源更新',
  },
  {
    id: 'update-8',
    time: '07-24',
    title: 'APP 3.0版本即将发布',
    description: '全新界面设计、智能推荐算法升级、离线下载功能上线，追剧体验全面进化。',
    tag: '版本预告',
  },
];

export const commentsData = [
  {
    id: 'comment-1',
    name: '追剧小达人',
    avatar: 'ri-user-3-line',
    rating: 5,
    content: '木瓜影视真的是我用了最久的追剧平台了，更新速度贼快，画质也很棒。最关键是没广告，追剧体验直接拉满！已经推荐给身边所有朋友了。',
    time: '3天前',
  },
  {
    id: 'comment-2',
    name: '夜深人不静',
    avatar: 'ri-user-3-line',
    rating: 5,
    content: '资源太全了！想看的国产剧、韩剧、美剧基本都能找到，而且高清资源加载很快。每天晚上睡前必刷，已经成为我的精神食粮了。',
    time: '5天前',
  },
  {
    id: 'comment-3',
    name: '电影发烧友',
    avatar: 'ri-user-3-line',
    rating: 4,
    content: '用了快一年了，整体体验很不错。分类清晰找剧方便，播放器也很流畅。希望后续能增加更多4K资源，大屏观看看4K真的爽。',
    time: '1周前',
  },
  {
    id: 'comment-4',
    name: '周末刷剧人',
    avatar: 'ri-user-3-line',
    rating: 5,
    content: '偶然发现的宝藏平台！界面干净清爽，没有乱七八糟的弹窗广告。周末窝在家一口气追完一整部剧的感觉太棒了，强烈推荐！',
    time: '1周前',
  },
];

export const faqData = [
  {
    id: 'faq-1',
    question: '木瓜影视是否需要付费观看？',
    answer: '木瓜影视所有电视剧资源均为免费在线观看，无需任何付费或会员订阅。我们致力于为用户提供零门槛的高清追剧体验，让每一位用户都能畅享精彩剧集。目前平台不设置任何付费墙或付费专区，全部内容免费开放。',
  },
  {
    id: 'faq-2',
    question: '视频播放支持哪些清晰度？卡顿怎么办？',
    answer: '平台支持标清、高清720P、超清1080P以及部分4K画质，您可以根据网络状况自由切换。我们部署了全球CDN加速节点，通常情况下播放流畅不卡顿。如遇卡顿，建议切换至较低清晰度或检查本地网络环境，也可尝试刷新页面。',
  },
  {
    id: 'faq-3',
    question: '新剧一般多久能上线？',
    answer: '我们拥有专业的内容更新团队，热门剧集通常在播出后数小时内即可同步上线。部分重点剧集支持实时追更，每日更新一集或多集。同时平台设有"即将上线"专区，方便您提前了解排播计划，不错过任何期待的剧集。',
  },
  {
    id: 'faq-4',
    question: '可以在手机或平板上观看吗？',
    answer: '完全可以！木瓜影视采用响应式设计，完美适配手机、平板、电脑等各种设备。您还可以下载木瓜影视APP（iOS/Android），享受更便捷的移动追剧体验，支持离线缓存、夜间模式等贴心功能。',
  },
  {
    id: 'faq-5',
    question: '平台上有哪些类型的电视剧？',
    answer: '我们覆盖了丰富的电视剧类型，包括国产剧、港剧、台剧、韩剧、日剧、美剧、英剧等。题材涵盖古装、悬疑、爱情、科幻、喜剧、刑侦、都市、年代、玄幻、动漫等，满足不同观众的多元追剧需求。',
  },
  {
    id: 'faq-6',
    question: '如何反馈问题或建议？',
    answer: '我们非常重视每一位用户的反馈。您可以通过页面底部的"联系我们"入口提交意见，或发送邮件至官方邮箱。我们的客服团队会在24小时内回复处理。同时欢迎加入官方社群，与其他追剧爱好者交流讨论。',
  },
];

export const rankingData = [
  {
    id: 'rank-1',
    rank: 1,
    title: '狂飙',
    subtitle: '刑侦 · 犯罪',
    hot: '986万热度',
    trend: 'up' as const,
    image: 'https://readdy.ai/api/search-image?query=Intense%20crime%20drama%20aesthetic%20with%20dark%20urban%20streets%20and%20police%20lights%2C%20high%20contrast%20coral%20and%20charcoal%20tones%2C%20cinematic%20noir%20poster%20style%2C%20dramatic%20lighting%2C%20abstract%20composition&width=400&height=240&seq=rank-kuangbiao-01&orientation=landscape',
  },
  {
    id: 'rank-2',
    rank: 2,
    title: '繁花',
    subtitle: '年代 · 商战',
    hot: '875万热度',
    trend: 'up' as const,
    image: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20aesthetic%20with%20neon%20lights%20and%20vintage%20street%20scene%2C%20warm%20golden%20and%20coral%20tones%2C%20nostalgic%20cinematic%20atmosphere%2C%20elegant%20composition%2C%20soft%20glow%20effects&width=400&height=240&seq=rank-fanhua-02&orientation=landscape',
  },
  {
    id: 'rank-3',
    rank: 3,
    title: '三体',
    subtitle: '科幻 · 悬疑',
    hot: '812万热度',
    trend: 'up' as const,
    image: 'https://readdy.ai/api/search-image?query=Cosmic%20abstract%20composition%20with%20three%20suns%20and%20mysterious%20signal%20waves%2C%20deep%20space%20background%2C%20coral%20and%20gold%20energy%20ripples%2C%20sci-fi%20cinematic%20aesthetic%2C%20epic%20scale&width=400&height=240&seq=rank-santi-03&orientation=landscape',
  },
  {
    id: 'rank-4',
    rank: 4,
    title: '庆余年',
    subtitle: '古装 · 权谋',
    hot: '756万热度',
    trend: 'stable' as const,
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20courtyard%20with%20falling%20cherry%20blossoms%2C%20golden%20sunset%20lighting%2C%20dramatic%20and%20elegant%20atmosphere%2C%20traditional%20aesthetic%20with%20cinematic%20color%20grading%2C%20warm%20coral%20tones&width=400&height=240&seq=rank-qingyun-04&orientation=landscape',
  },
  {
    id: 'rank-5',
    rank: 5,
    title: '隐秘的角落',
    subtitle: '悬疑 · 剧情',
    hot: '698万热度',
    trend: 'up' as const,
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20seaside%20town%20at%20dusk%20with%20long%20shadows%2C%20psychological%20thriller%20vibe%2C%20dark%20and%20moody%20with%20coral%20sunset%20accents%2C%20cinematic%20film%20noir%20style%2C%20suspenseful%20atmosphere&width=400&height=240&seq=rank-yinmi-05&orientation=landscape',
  },
  {
    id: 'rank-6',
    rank: 6,
    title: '长安十二时辰',
    subtitle: '古装 · 悬疑',
    hot: '623万热度',
    trend: 'down' as const,
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Tang%20dynasty%20watchtower%20at%20night%20with%20lanterns%20and%20full%20moon%2C%20dramatic%20lighting%2C%20warm%20coral%20and%20deep%20blue%20contrast%2C%20cinematic%20historical%20epic%20aesthetic&width=400&height=240&seq=rank-changan-06&orientation=landscape',
  },
];

export const aboutData = {
  title: '关于木瓜影视',
  description: '木瓜影视成立于2020年，是国内领先的高清电视剧在线观影平台。我们致力于为用户提供海量、高清、免费的电视剧资源，打造极致的在线追剧体验。平台汇聚了超过10万部国内外精品剧集，涵盖国产、港台、日韩、欧美等多种类型，每日更新50部以上，确保用户始终能观看到最新、最热的电视剧内容。我们始终坚持"用户至上"的理念，不断优化播放技术和内容质量，为全国数千万追剧爱好者提供稳定、流畅、高清的观影服务。',
  stats: [
    { value: '2020年', label: '成立时间' },
    { value: '10万+', label: '剧集资源' },
    { value: '800万+', label: '月活跃用户' },
    { value: '99.9%', label: '服务可用率' },
  ],
};

export const indexData = [
  {
    id: 'index-1',
    title: '古装剧',
    count: '3,280部',
    icon: 'ri-sword-line',
  },
  {
    id: 'index-2',
    title: '悬疑剧',
    count: '1,950部',
    icon: 'ri-search-eye-line',
  },
  {
    id: 'index-3',
    title: '都市爱情',
    count: '2,640部',
    icon: 'ri-heart-line',
  },
  {
    id: 'index-4',
    title: '科幻剧',
    count: '890部',
    icon: 'ri-rocket-2-line',
  },
  {
    id: 'index-5',
    title: '刑侦犯罪',
    count: '1,420部',
    icon: 'ri-police-car-line',
  },
  {
    id: 'index-6',
    title: '家庭伦理',
    count: '1,760部',
    icon: 'ri-home-heart-line',
  },
  {
    id: 'index-7',
    title: '喜剧',
    count: '2,100部',
    icon: 'ri-emotion-laugh-line',
  },
  {
    id: 'index-8',
    title: '年代剧',
    count: '1,180部',
    icon: 'ri-history-line',
  },
];

export const featuresData = [
  {
    id: 'feature-1',
    title: '海量资源',
    description: '超过10万部高清电视剧，涵盖全球热门剧集，每日更新不间断，追剧资源一网打尽。',
    icon: 'ri-database-2-line',
  },
  {
    id: 'feature-2',
    title: '极速播放',
    description: '全球CDN加速，1080P超清秒加载。智能码率自适应，网络不佳也能流畅观影。',
    icon: 'ri-speed-line',
  },
  {
    id: 'feature-3',
    title: '纯净无广告',
    description: '全程无贴片广告、无弹窗、无强制跳转，给你最纯净的追剧体验。',
    icon: 'ri-shield-check-line',
  },
  {
    id: 'feature-4',
    title: '多端同步',
    description: '电脑、手机、平板无缝切换，观影进度自动同步，随时随地接着看。',
    icon: 'ri-device-line',
  },
  {
    id: 'feature-5',
    title: '智能推荐',
    description: '基于观影偏好智能推荐，帮你发现更多好剧。个性化首页，越用越懂你。',
    icon: 'ri-magic-line',
  },
];

export const topicsData = [
  { id: 'topic-1', name: '古装权谋', count: '326万讨论' },
  { id: 'topic-2', name: '烧脑悬疑', count: '285万讨论' },
  { id: 'topic-3', name: '国产好剧', count: '512万讨论' },
  { id: 'topic-4', name: '韩剧推荐', count: '198万讨论' },
  { id: 'topic-5', name: '美剧精选', count: '165万讨论' },
  { id: 'topic-6', name: '高分神作', count: '438万讨论' },
  { id: 'topic-7', name: '新剧速递', count: '372万讨论' },
  { id: 'topic-8', name: '经典重温', count: '253万讨论' },
  { id: 'topic-9', name: '追剧打卡', count: '591万讨论' },
];

export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '热度榜单', href: '#ranking' },
  { label: '联系我们', href: '#contact' },
  { label: '最新动态', href: '#updates' },
  { label: '焦点专题', href: '#carousel' },
];